import actionTypes from './actionTypes';

const INITIAL_STATE = {
  getTakeawayFactorLoading: false,
  getTakeawayFactorFailed: false,
  getTakeawayFactorError: false,
  getTakeawayFactorMessage: null,
  takeawayFactorList: [],
  totalRecords: null,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case actionTypes.GET_TAKEAWAY_FACTOR_LOADING:
      return {
        ...state,
        getTakeawayFactorLoading: true,
        getTakeawayFactorFailed: false,
        getTakeawayFactorError: false,
        getTakeawayFactorMessage: null,
        takeawayFactorList: [],
        totalRecords: null,
      };

    case actionTypes.GET_TAKEAWAY_FACTOR_SUCCESS:
      return {
        ...state,
        getTakeawayFactorLoading: false,
        getTakeawayFactorFailed: false,
        getTakeawayFactorError: false,
        getTakeawayFactorMessage: null,
        takeawayFactorList: [...action.payload.factors],
        totalRecords: action.payload.totalRecords,
      };
    case actionTypes.GET_TAKEAWAY_FACTOR_FAILED: {
      let { message } = action.payload;
      return {
        ...state,
        getTakeawayFactorLoading: false,
        getTakeawayFactorFailed: true,
        getTakeawayFactorError: false,
        getTakeawayFactorMessage: message,
        takeawayFactorList: [],
        totalRecords: null,
      };
    }

    case actionTypes.GET_TAKEAWAY_FACTOR_REJECT:
      return {
        ...state,
        getTakeawayFactorLoading: false,
        getTakeawayFactorFailed: false,
        getTakeawayFactorError: true,
        getTakeawayFactorMessage: null,
        takeawayFactorList: [],
        totalRecords: null,
      };

    default:
      return state;
  }
};
